import { render, staticRenderFns } from "./AyudaTemaGeneral.vue?vue&type=template&id=3efe8d8c"
import script from "./AyudaTemaGeneral.vue?vue&type=script&lang=js"
export * from "./AyudaTemaGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports